export type FilterKey = "all" | "pending" | "accepted" | "ready" | "refused";

export type FilterConfig = {
    enabled: boolean;
    color: string;
};

export type SortKey =
    | "pendingFirst"
    | "mostRecent"
    | "oldest"
    | "tableNumberAsc"
    | "tableNumberDesc"
    | "totalDesc"
    | "totalAsc";

export type CommandesState = {
    filters: Record<FilterKey, FilterConfig>;
    sortOptions: Record<SortKey, boolean>;
};

export const DEFAULT_FILTERS: Record<FilterKey, FilterConfig> = {
    all: { enabled: true, color: "#333333" },
    pending: { enabled: true, color: "#FF9800" },
    accepted: { enabled: true, color: "#4CAF50" },
    ready: { enabled: true, color: "#2196F3" },
    refused: { enabled: true, color: "#F44336" },
};

export const DEFAULT_SORT_OPTIONS: Record<SortKey, boolean> = {
    pendingFirst: true,
    mostRecent: true,
    oldest: true,
    tableNumberAsc: true,
    tableNumberDesc: true,
    totalDesc: true,
    totalAsc: true,
};
